import xhr from '@/tool/http/http'
import {console} from "vuedraggable/src/util/helper";

/* 咨询安排列表 */
export const getStudentInfo = sn => xhr.GET(`/api/common/student-info/${sn}`)

/* 咨询安排列表 */
export const counselingPlanList = query => xhr.GET('/api/counseling/listWaitCounselingWithDTO', query)
/* 咨询安排导出 */
export const exportCounselingPlanList = query => xhr.EXPORT('/api/counseling/exportCounselingPlanList', query)
/* 咨询条件导出 */
export const exportCounseling = query => xhr.EXPORT('/api/counseling/exportCounseling', query)
/* 咨询条件导出-管理员 */
export const exportCounselingByAdmin = query => xhr.EXPORT('/api/counseling/exportCounselingByAdmin', query)
/* 咨询列表 */
export const counselingList = query => xhr.GET('/api/counseling/listCounselingWithDTO', query)
/* 开始咨询 */
export const updateConsultation = (id, query) => xhr.PUT(`/api/counseling/${id}`, query)
/* 获取数据字典 */
export const attachMore = query => xhr.POST('/api/dictionary/common/attachMore', query)
/* 查询所有咨询记录 */
export const counselingAllList = query => xhr.GET('/api/counseling/list', query)
/* 查询当前学生是否有初访或咨询 */
export const visitAndCounseling = sn => xhr.GET('/api/counseling/listAll', sn)
// 权限相关
export const mockLogin = userInfo => xhr.POST('/api/auth/logins', userInfo)
export const switchRole = roleCode => xhr.POST(`/api/auth/role/switch/${roleCode}`)
export const getUserInfo = () => xhr.POST('/api/auth/user-info')

// 数据字典
export const getDictItemsByType = type => xhr.GET(`/api/dictionary/items/${type}`) // 单个获取

// 时间设定
export const getTimeSettingList = query => xhr.GET('/api/userTimeSetting/list', query) // 获取时间设定列表
export const saveTimeSetting = timeSetting => xhr.POST('/api/userTimeSetting/', timeSetting)
export const removeTimeSetting = id => xhr.DELETE(`/api/userTimeSetting/${id}`)
export const listConflictTimeSettings = query => xhr.POST('/api/userTimeSetting/list/conflicts', query)

// 额外时间设定
export const getExtraTimeSettingList = query => xhr.GET('/api/userExtraTimeSetting/list', query)
export const saveExtraTimeSetting = timeSetting => xhr.POST('/api/userExtraTimeSetting/', timeSetting)
export const removeExtraTimeSetting = id => xhr.DELETE(`/api/userExtraTimeSetting/${id}`)

// 系统设定
export const getSysSettingList = () => xhr.GET('/api/sysSetting/list') // 获取系统设定列表

// 获取学生咨询经历
export const getExperienceList = (query, pageHelper) => xhr.GET('/api/counselingExperience/list', query, pageHelper)
export const deleteExperience = id => xhr.DELETE(`/api/counselingExperience/${id}`)
// 初访列表
export const getFirstList = (query, pageHelper) => xhr.GET('/api/firstVisit/listWithDTO', query, pageHelper)
// 根据优先级排序获取
export const getFirstListByQuery = query => xhr.POST('/api/firstVisit/listByQuery', query)
// 根据状态排序获取
export const getFirstListByQueryWithStatus = query => xhr.POST('/api/firstVisit/listByQueryWithStatus', query)
// 学生删除初访申请
export const delVisit = id => xhr.DELETE(`/api/firstVisit/${id}`)
// 修改初访信息
export const calVisit = query => xhr.PUT(`/api/firstVisit/${query.id}`, query)
export const updateVisit = query => xhr.PUT('/api/firstVisit/update', query)
export const deleteException = query => xhr.PUT('/api/firstVisit/deleteException', query)
// 安排初访
export const planVisit = query => xhr.PUT(`/api/firstVisit/planVisit/${query.id}`, query)
// 获取数据字典
export const getDic = query => xhr.POST('/api/dictionary/common/attachMore', query)
// 获取心理测试表
export const getEva = () => xhr.GET('/api/studentEvaluationItem/listAll')
// 提交初访信息
export const subRegistration = query => xhr.POST('/api/firstVisit/addVisit', query)
export const addVisit = query => xhr.POST('/api/firstVisit/', query)
//
export const addVisitCheck = query => xhr.POST('/api/firstVisit/addFirstVisit', query)
// 录入初访结果
export const addConclusion = query => xhr.POST('/api/firstVisit/addConclusion', query)
// 中心管理员导出
export const exportFirsitVisit = query => xhr.EXPORT('/api/firstVisit/export', query)
// 初访员导出
export const exportByReporter = query => xhr.EXPORT('/api/firstVisit/exportByReporter', query)
// 初访列表导出
export const exportList = query => xhr.EXPORT('/api/firstVisit/exportList', query)
// 初访成功导出
export const exportSuccess = query => xhr.EXPORT('/api/firstVisit/exportSuccess', query)
// 根据id获取初访信息
export const getVisitById = id => xhr.GET(`/api/firstVisit/${id}`)
// 获取最近生活质量
export const getQuantity = () => xhr.GET('/api/lifeQuantityEvaluation/list')
// 获取生活经历分数表
export const getLife = query => xhr.GET('/api/firstVisitLifeQuantityEvaluation/list', query)
// 添加初访经历
export const addExperience = query => xhr.POST('/api/counselingExperience/', query)

// 初访
export const getFirstVisitDateSlots = campus => xhr.GET(`/api/firstVisit/date-slots/week/${campus}`) // 获取日期slots
export const autoRangeVisits = payload => xhr.GET('/api/firstVisit/date-slots/auto-range', payload) // 获取日期slots
export const reserveFirstVisit = payload => xhr.POST('/api/firstVisitReservation/', payload)
export const getReservationList = query => xhr.GET('/api/firstVisitReservation/list', query)
export const removeReserve = id => xhr.DELETE(`/api/firstVisitReservation/${id}`)
export const getFirstVisitScheduleByCampus = campus => xhr.GET(`/api/firstVisit/schedule/${campus}`)
export const getFirstVisitAvailableDateTimeSlots = query => xhr.GET('/api/firstVisit/date-slots/available/', query) // 列出可预约的时间段及老师
export const batchUpdateFirstVisit = payload => xhr.PUT('/api/firstVisit/batch-update', payload)

// 咨询报告
export const recordList = query => xhr.GET('/api/counselingRecord/list', query)
// 保存咨询报告
export const saveRecord = (id, query) => xhr.PUT(`/api/counselingRecord/${id}`, query)
// 保存咨询报告(结案脱落)
export const updateRecordJaOrTl = (id, query) => xhr.PUT(`/api/counselingRecord/updateRecordJaOrTl/${id}`, query)
// 咨询次数申请
export const submitApply = counselingExtend => xhr.POST('/api/counselingExtendApplication/', counselingExtend)
// 次数申请历史
export const applyHistory = query => xhr.GET('/api/counselingExtendApplication/list', query)
/* 下载结案报告 */
export const exportResult = query => xhr.EXPORT('/api/counseling/exportCounselingResult', query)
/* 获取所有咨询次数申请 */
export const auditList = query => xhr.GET('/api/counselingExtendApplication/list', query)
/* 审核咨询次数申请 */
export const auditApply = (id, query) => xhr.PUT(`/api/counselingExtendApplication/auditApply/${id}`, query)
/* 获取所有用户列表 */
export const userList = query => xhr.GET('/api/user/listUser', query)
/* 修改用户 */
export const saveUser = (id, query) => xhr.PUT(`/api/user/${id}`, query)
/* 根据学号查询用户 */
export const queryUserBySn = sn => xhr.GET(`/api/user/getUserBySn?sn=${sn}`)
/* 添加用户 */
export const insertUser = user => xhr.POST('/api/user/saveUser', user)
/* 获取所有咨询员/初访员 */
export const getUserListByType = query => xhr.GET('/api/user/getUserListByType', query)
/* 修改用户 */
export const updateUser = user => xhr.POST('/api/user/updateUser', user)
/* 检查用户的咨询、初访绑定信息 */
export const checkExistCouVis = sn => xhr.GET(`/api/user/checkExistCouVis?sn=${sn}`)
/* 启用、禁用用户 */
export const userEnable = user => xhr.POST('/api/user/userEnable', user)
/* 获取角色 */
export const roleList = query => xhr.GET('/api/role/list', query)
/* 验证用户角色 */
export const checkUserRole = sn => xhr.GET(`/api/user/checkUserRole?sn=${sn}`)
/* 获取学院 */
export const collegeList = () => xhr.GET('/api/dictionaryMassage/collegeList')
/* 根据学院sn获取专业 */
export const majorsByCollege = sn => xhr.GET(`/api/dictionaryMassage/getMajorsByCollege?sn=${sn}`)
/* 导出用户 */
export const exportUser = query => xhr.EXPORT('/api/user/exportUser', query)
/* 根据学号获取学生信息 */
export const studentBySn = sn => xhr.GET(`/api/user/getStudentBySn?sn=${sn}`)
export const getStudentInformation = sn => xhr.GET(`/api/user/getStudentInformation?sn=${sn}`)
/* 初访结束添加咨询信息 */
export const insertCounseling = counseling => xhr.POST('/api/counseling/', counseling)
/* 根据学生名字查询 */
export const studentByName = name => xhr.GET(`/api/dictionaryMassage/getStudentByName?name=${name}`)

export const getTeacherList = () => xhr.GET('/api/user/list') // 获取咨询师列表
export const getCampusForTeacher = query => xhr.GET('/api/userCampus/list', query)

export const getclassroomlist = () => xhr.GET('/api/classRoom/list') // 获取教室列表
export const addclassRoom = query => xhr.POST('/api/classRoom/', query) // 添加教室
export const deleteclassRoom = id => xhr.DELETE(`/api/classRoom/${id}`) // 删除教室
export const changeclassRoomStatus = (id, query) => xhr.PUT(`/api/classRoom/${id}`, query) // 改变教室启用
export const updateClassRoom = (id, query) => xhr.PUT(`/api/classRoom/${id}`, query) // 改变教室信息
export const updateClassroomOldInfo = id => xhr.GET(`/api/classRoom/${id}`) // 获得要修改的教室
export const updateClassroomNewinfo = (id, query) => xhr.PUT(`/api/classRoom/updateClassInfo/${id}`, query) // 添加教室
export const getCampusList = type => xhr.GET(`/api/dictionary/items/${type}`) // 从数据字典获取校区列表

export const getsysTimeSetting = () => xhr.GET('/api/sysSetting/list') // 获取配置时间
export const setsysintervalTime = (id, query) => xhr.PUT(`/api/sysSetting//${id}`, query) // 添加教室

export const getcounselrecordList = () => xhr.GET('/api/counselingRecord/listAll') // 获取咨询记录

export const getAvailableDateTimeSlots = query => xhr.GET('/api/counseling/date-slots/available', query) // 获取咨询日期slots
export const arrangeCounseling = payload => xhr.POST('/api/counseling/arrange', payload) // 安排咨询
export const getCounselingByCampus = campus => xhr.GET(`/api/counseling/schedule/${campus}`)

// 教室API
export const getClassRoomList = query => xhr.GET('/api/classRoom/list', query) // 查询教室
// 管理员直接添加学生咨询
export const addCounseling = payload => xhr.POST('/api/counseling/addCounselingByAdmin', payload) // 安排咨询

export const getDictList = query => xhr.POST('/api/dictionary/common/attachMore', query)

export const getUserBySn = sn => xhr.GET('/api/common/getUser/' + sn)

export const evaluateApplication = paylaod => xhr.POST('/api/applications/evaluate', paylaod)

export const saveUnitRating = paylaod => xhr.POST('/api/unitRating/', paylaod)

export const listUnitRating = params => xhr.GET('/api/unit/rating', params)

export const listUnitRatingRecords = params => xhr.GET('/api/unitRating/list', params)
export const listUnitRank = params => xhr.GET('/api/unitRank/list', params)
export const saveUnitRank = payload => xhr.POST('/api/unitRank/', payload)
export const deleteUnitRank = id => xhr.POST('/api/unitRank/' + id)
export const listValidity = () => xhr.POST('/api/units/query')

export const savestudentRecommend = (payload) => xhr.POST('/api/studentRecommend/', payload)
export const updateStudentRecommend = (id, payload) => xhr.POST('/api/studentRecommend/' + id, payload)
export const deleteStudentRecommend = (id) => xhr.POST('/api/studentRecommend/delete' + id)
export const listStudentRecommend = (query) => xhr.GET('/api/studentRecommend/list', query)
export const uploadFileURL = `${process.env.BASE_URL}/api/file/upload-file`
export const fileDownload = query => xhr.EXPORT(`/api/file/download`, query)
